// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    Typography
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import Swal from 'sweetalert2'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(45, 'days').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        let url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-general-ledger'

        axios
            .get(url, {
                params: {
                    tgl_awal: tglAwal,
                    tgl_akhir: tglAkhir
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)

                    Swal.close()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const ActionButtons = ({ row, onNavigate }: {
        row: any;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Cetak Invoice",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/acc/invoice/pdf/' + row.id, '_blank')
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 150,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onNavigate={(id) => navigate('/acc/invoice/detail/' + id)}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'Dokumen',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <div style={{ cursor: 'pointer' }} onClick={() => {
                            window.open(`${row.data.link_Dokumen}`, '_blank')
                        }}>
                            <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                {row.data.Dokumen}
                            </Typography>
                        </div>
                    </Box>
                )
            }
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='GENERAL LEDGER' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={getData}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <MsiDatagrid
                        array={listData}
                        convertRupiah={[
                            'debet', 'kredit'
                        ]}
                        hiddenColumns={['link_Dokumen', 'id']}
                        customRender={convertComponent}
                    />
                </div>
            </Grid>
        </Grid>
    )
}
